import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import ErrorBaseLayout from '@/pages/Errors/errorBaseLayout.tsx';
import {useAuthUtils} from "@/hooks/useAuthUtils.ts";

export default function AccessRestricted() {
  const { t } = useTranslation();
  const {authRedirect} = useAuthUtils();
  return (
    <ErrorBaseLayout>
      <h1 className="text-4xl  font-bold">
        {t('Error.AccessRestricted')}
      </h1>

      <div className="mt-[30px] flex flex-col gap-8 text-lg">
        <p className="font-bold">
          {t('Error.AccessRestrictedPermissionMessage')}
        </p>
        <p>{t('Error.InsufficientAuthorizationMessage')}</p>
        <p>{t('Error.AccessRestrictedContactMessage')}</p>
        <div className="flex gap-3">
          <Button
            variant="default"
            onClick={() => authRedirect()}
          >
            {t('ChangeClientController.ReturnToAuthorizationPortal')}
          </Button>
        </div>
        <p>
          <span className="font-bold">{t('Error.ErrorCode')}:</span>{' '}
          {t('Error.AccessRestrictedCode')}
        </p>
      </div>
    </ErrorBaseLayout>
  );
}
